//////////////////////////////////////////////////////////////////////
//
//  09/28/18
//  src/containers/Main.js
//
//  This file is the top level Main javascript file.
//
//  Note: I tried to add a component for the 404 "Not Found" error.
//  But, I'm not sure it will ever be called.  Which could be fine if 
//  everything that was not found goes to the 'MainHome' page.  I was
//  trying to fix a '404' error I was getting when testing on an actual
//  website, that was a sub-directory: "devtest.lnpsoftware.com/test".
//
//  The error happens when you type in "devtest.lnpsoftware.com/test/compact".
//
//  This is how to fix that issue... setup a 'server' side node.js file and run it on the server.
//  https://stackoverflow.com/questions/27928372/react-router-urls-dont-work-when-refreshing-or-writting-manually#36623117
//

import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { withRouter }  from "react-router-dom";
import { connect    }  from "react-redux";
import { setCkBox }    from "../store/actions/navbar";
import { setTopSt }    from "../store/actions/navbar";
import MainMap         from "./MainMap";
import MainHome        from "./MainHome";
import MainFull        from "./MainFull";
import MainCompact     from "./MainCompact";
import MainLogin       from "./MainLogin";
import MainNotFound404 from "./MainNotFound404";
import './Main.css';

class Main extends Component {
  render() {
    console.log( "Main - Test Route: " );
    console.log( this.props );
    console.log( "Path: " + this.props.location.pathname );
    console.log( "Pubic URL: " + process.env.PUBLIC_URL );

    this.matchPathToCkBox( this.props );

    return (
      <div>
        <Switch>
          <Route path={ `${ process.env.PUBLIC_URL }/map` }     render={ () => { return ( <MainMap     { ...this.props } /> ); } } />
          <Route path={ `${ process.env.PUBLIC_URL }/full` }    render={ () => { return ( <MainFull    { ...this.props } /> ); } } />
          <Route path={ `${ process.env.PUBLIC_URL }/compact` } render={ () => { return ( <MainCompact { ...this.props } /> ); } } />
          <Route path={ `${ process.env.PUBLIC_URL }/login` }   render={ () => { return ( <MainLogin heading="Login" { ...this.props } /> ); } } />
          <Route path={ `${ process.env.PUBLIC_URL }/` }        render={ () => { return ( <MainHome { ...this.props } /> ); } } />
          <Route component={ MainNotFound404 } />
        </Switch>
      </div>
    );
  }

  // 
  //  I noticed that when someone reloads the web page and it is not the
  //  'main' page, the default for the center select check boxes is 'map'
  //  and if the web page is not 'map' but something like 'full' then the
  //  check boxes are incorrect.  To fix that we must test the 'path' with
  //  current check box selection and update the check boxes to match the 
  //  web page.
  //
  matchPathToCkBox( props ) {
    if( props.location !== undefined ) {
      if( props.location.pathname !== "" ) {
        // grab the path name only.
        var tmp1 = props.location.pathname;
        // If there is a sub-folder, find it and pull out.
        var tmp2 = tmp1.replace( process.env.PUBLIC_URL, "" );
        console.log( tmp1 );
        console.log( tmp2 );
        // Now Split out the rest of the data.
        var tmp = tmp2.split( '/' );
        console.log( tmp );
        
        // Note: '/' shows up as "" so we do not make any changes for that page.
        if( props.navbar.ckBox !== "" ) {
          // get both the 'path' and the 'ckbox'
          var path  = tmp[ 1 ].trim().toLowerCase();
          var ckbox = props.navbar.ckBox;
          var topst = props.navbar.topSt;

          console.log( "Found Sub-directory: " + path + ", topSt: "+ topst + ", ckBox: " + ckbox );
          
          if( path === "" ){                   // Make sure State is set to 'city'
            if( topst !== "city" ) {
              props.dispatch( setTopSt( "city" ) );
            }
          } else if( path === "login" ) {         // Make sure State is set to 'login'
            if( topst !== "login" ) {
              props.dispatch( setTopSt( "login" ) );
            }
          } else if( path !== ckbox ) {  // If not the same and the 'path' is not for the 'login' page, then change.
            console.log( "Change CkBox to match Path: " + path );
            props.dispatch( setCkBox( path ) );
          }
        }
      }
    }
  }
}

function mapStateToProps( state ) {
  console.log( "Main State to Props, ckBox: " + state.navbar.ckBox + ", topSt: " + state.navbar.topSt + ", sCat: " + state.navbar.sCat );
  return {
    navbar : state.navbar
  }
}

export default withRouter( connect( mapStateToProps, null )( Main ));



// WEBPACK FOOTER //
// ./src/containers/Main.js